import { useEffect, useRef, useState } from 'react';
import { useWatch } from 'react-hook-form';

import { GLOBAL_UNIT_NAME } from '../../Global/form';

export const useUnitChange = () => {
  const unit = useWatch({ name: GLOBAL_UNIT_NAME });
  const [key, setKey] = useState(unit);
  const [isLoading, setIsLoading] = useState(false);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    
    setIsLoading(true);

    setTimeout(() => {
      setKey(unit);
      setIsLoading(false);
    }, 500);
  }, [unit]);

  return { key, isLoading };
};
